import { Grid, NumberInput } from "@mantine/core";
import { CreatableSelect } from "components";
import { FormikProps } from "formik";
import { FC } from "react";
import { useListProduct } from "utils/hooks/request/useProducts";
import { useListWarehouse } from "utils/hooks/request/useWarehouses";

interface InventoryFormFieldsProps {
  formik: FormikProps<any>;
  isCreateMode?: boolean;
}

const spanHalf = { base: 12, md: 6 };

const InventoryFormFields: FC<InventoryFormFieldsProps> = ({
  formik,
  isCreateMode = false,
}) => {
  const { productOptions } = useListProduct();
  const { warehouseOptions } = useListWarehouse();

  const getFieldError = (field: string) =>
    formik.touched[field] && formik.errors[field]
      ? (formik.errors[field] as string)
      : null;

  return (
    <Grid>
      {isCreateMode && (
        <Grid.Col span={spanHalf}>
          <CreatableSelect
            label="Mặt hàng"
            placeholder="Chọn mặt hàng"
            withAsterisk
            data={productOptions ?? []}
            value={formik.values.productId}
            onChange={(value) => formik.setFieldValue("productId", value)}
            onBlur={() => formik.setFieldTouched("productId", true)}
            error={getFieldError("productId")}
            allowCreate={false}
          />
        </Grid.Col>
      )}

      {isCreateMode && (
        <Grid.Col span={spanHalf}>
          <CreatableSelect
            label="Kho"
            placeholder="Chọn kho"
            withAsterisk
            data={warehouseOptions ?? []}
            value={formik.values.warehouseId}
            onChange={(value) => formik.setFieldValue("warehouseId", value)}
            onBlur={() => formik.setFieldTouched("warehouseId", true)}
            error={getFieldError("warehouseId")}
            allowCreate={false}
          />
        </Grid.Col>
      )}

      <Grid.Col span={12}>
        <NumberInput
          label="Số lượng"
          placeholder="Nhập số lượng"
          withAsterisk
          min={0}
          value={formik.values.quantity}
          onChange={(value) => formik.setFieldValue("quantity", value)}
          onBlur={() => formik.setFieldTouched("quantity", true)}
          error={getFieldError("quantity")}
        />
      </Grid.Col>
    </Grid>
  );
};

export default InventoryFormFields;
